import React from "react";
import styles from "./TextView.module.scss";
import {
  ButtonSettings,
  ElementType,
  ElementViewProps,
  TextSettings,
} from "@/shared/types";

export interface TextViewProps extends ElementViewProps {
  minWidth?: string;
}

const TextView: React.FC<TextViewProps> = ({
  element,
  text,
  minWidth,
  elementContentRef,
}) => {
  const values = element?.settings as TextSettings;
  const buttonSettings = element?.settings as ButtonSettings;
  const textId =
    element?.type === ElementType.Button
      ? (buttonSettings?.design as any)?.textId ?? buttonSettings?.textId
      : values?.textId;

  return (
    <div
      ref={elementContentRef as React.RefObject<HTMLDivElement>}
      id={element?.id}
      data-test="TextView"
      className={styles.text}
      style={{ width: "fit-content", minWidth }}
      dangerouslySetInnerHTML={{
        __html: text?.[textId!] || "",
      }}
    />
  );
};

export { TextView };
